import { Table } from "components/Common/Table/Table";
import { ROUTER_PATH } from "config/path";
import dayjs from "dayjs";
import React from "react";
import { useNavigate } from "react-router-dom";

interface NoticeDashboardTableRowProps {
  id: string;
  no: number;
  title: string;
  author: string;
  createdAt: string;
  updatedAt: string;
}

const NoticeDashboardTableRow = ({
  id,
  no,
  title,
  author,
  createdAt,
  updatedAt,
}: NoticeDashboardTableRowProps) => {
  const navigate = useNavigate();
  return (
    <Table.Tr
      style={{
        cursor: "pointer",
      }}
      onClick={() => navigate(ROUTER_PATH.notice.dashboard.detail(id))}
    >
      <Table.Td>{no.toString()}</Table.Td>
      <Table.Td>{title}</Table.Td>
      <Table.Td>{author}</Table.Td>
      <Table.Td>{dayjs(createdAt).format("YYYY-MM-DD")}</Table.Td>
      <Table.Td>{dayjs(updatedAt).format("YYYY-MM-DD")}</Table.Td>
    </Table.Tr>
  );
};

export default NoticeDashboardTableRow;
